import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/base/bankaccount/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/base/bankaccount/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/base/bankaccount/delete?id=' + params, Object.assign({}, options, {}));

export const add = (params, options) =>
  request.post('/api/base/bankaccount/submit', params, options);

export const update = (params, options) =>
  request.post('/api/base/bankaccount/submit', params, options);

export const getbank = (params, options) =>
  request.get(
    '/api/blade-system/dict/dictionary?code=bill_cutBank',
    Object.assign({}, options, { params })
  );
